"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _dealerLogo = _interopRequireDefault(require("../../styles/dealer-logo.css"));
var _checkProps = _interopRequireDefault(require("../../utils/checkProps"));
var DealerLogo = function DealerLogo(_ref) {
  var logo = _ref.logo,
    name = _ref.name;
  if (!(0, _checkProps["default"])(logo) || !(0, _checkProps["default"])(name)) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerLogo["default"].dealerLogoContainer
    }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      src: logo,
      alt: name,
      className: _dealerLogo["default"].dealerLogo
    }));
  }
  return null;
};
var _default = DealerLogo;
exports["default"] = _default;